'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _themeSections = require('@shopify/theme-sections');

exports.default = (0, _themeSections.register)('template-account', {
  onLoad: function onLoad() {
    var dropdownNavs = document.querySelectorAll('[data-account-dropdown-nav]');
    if (dropdownNavs) {
      dropdownNavs.forEach(function (nav, index) {
        nav.addEventListener('change', function (event) {
          if (event.target.checked) {
            window.location.href = event.target.value;
          }
        }.bind(this));
      }.bind(this));
    }
  },


  /**
   * Event callback for Theme Editor `section:unload` event
   */
  onUnload: function onUnload() {}
});